export const calendarDayOfWeek_Monday = "KdlV3d";
export default {calendarDayOfWeek_Monday};